import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {

  connect() {

    // TODO: Fix the layout thrashing and lack of compositing
    // that animating width causes
    requestAnimationFrame(() => {
      $(this.element).progress();
    });

  }

  disconnect() {
    $(this.element).progress("destroy");
  }
  
}
